import React from "react";
import "../styles/PrivacyPolicy.css";

const OPEN_ROLES = [
  {
    title: "Sales & Business Development Executive",
    type: "Full-time · Bengaluru",
    admin: "On-site",
    purpose: "Build relationships with developers and brokers, and help grow our listings network across Bengaluru.",
  },
  {
    title: "Backend Engineer (Python/FastAPI)",
    type: "Full-time · Bengaluru / Remote",
    admin: "Hybrid",
    purpose: "Work on our property search platform, AI-driven chat assistant, and real-time video-tour infrastructure.",
  },
  {
    title: "Customer Support Associate",
    type: "Full-time · Bengaluru",
    admin: "On-site",
    purpose: "Be the first point of contact for buyers, sellers, and brokers using the platform.",
  },
];

/**
 * Static Careers page: culture blurb + illustrative open roles + how to
 * apply. There's no applicant-tracking backend yet, so applications route
 * to the team inbox directly.
 */
export default function Careers() {
  return (
    <div className="pp-page">
      <div className="pp-container">

        <div className="pp-hero">
          <div className="pp-hero-badge">Careers</div>
          <h1 className="pp-h1">Build the Future of Real Estate With Us</h1>
          <p className="pp-intro">
            We're not a typical real estate company -- We're a small team of
            engineers and real-estate professionals building a platform that
            puts clear, honest information in front of every buyer, renter,
            and seller in India. If that sounds like your kind of problem to
            work on, we'd like to hear from you.
          </p>
        </div>

        <section className="pp-section">
          <h2 className="pp-h2">Open Roles</h2>
          <div className="pp-cookie-grid">
            {OPEN_ROLES.map((r) => (
              <div className="pp-cookie-card" key={r.title}>
                <div className="pp-cookie-title">{r.title}</div>
                <div className="pp-cookie-row"><span>Type</span><b>{r.type}</b></div>
                <div className="pp-cookie-row"><span>Work mode</span><b>{r.admin}</b></div>
                <p style={{ fontSize: 13, color: "#64748b", margin: "10px 0 0" }}>{r.purpose}</p>
              </div>
            ))}
          </div>
          <p style={{ marginTop: 18 }}>
            Don't see a role that fits? We're always happy to hear from people
            who are excited about what we're building -- send us Your resume
            regardless.
          </p>
        </section>

        <div className="pp-contact">
          <div className="pp-contact-icon">💼</div>
          <h2 className="pp-h2" style={{ marginBottom: 8 }}>How to Apply</h2>
          <p style={{ margin: "0 0 16px" }}>
            Email Your resume and a short note about the role You're
            interested in to:
          </p>
          <a href="mailto:info@oneglobalmarketplace.com?subject=Careers%20Application" className="pp-contact-link">
            info@oneglobalmarketplace.com →
          </a>
        </div>

      </div>
    </div>
  );
}
